import React from 'react'

import { InitState } from '../../../../../../../../redux/reducers/root/initialState'
import { MultimediaUploaderType } from '../../../../../../../../@types/multimedia-types'
import { useAppSelector } from '../../../../../../../../app/hooks'
import MultimediaVideoButtonStateWrapper from './button/video/MultimediaVideoButtonStateWrapper'
import MultimediaButtonStateWrapper from './button/nonVideo/MultimediaButtonStateWrapper'

export type MultimediaButtonWrapperTypes = {
  allowedFileType: MultimediaUploaderType
  isFloorPlan: boolean
}

const MultimediaButtonProvider: React.FC<MultimediaButtonWrapperTypes> = ({ allowedFileType, isFloorPlan }) => {
  const flowInformation = useAppSelector((state: InitState) => state.flowFeature.flowInformation)
  const entryMode = useAppSelector(
    (state: InitState) => state.insertionFeature.insertionIdentification.metaInformation?.entryMode
  )

  return (
    <div>
      {allowedFileType !== MultimediaUploaderType.VIDEO ? (
        <MultimediaButtonStateWrapper
          allowedFileType={allowedFileType}
          isFloorPlan={isFloorPlan}
          flowInformation={flowInformation}
          entryMode={entryMode}
        />
      ) : (
        <MultimediaVideoButtonStateWrapper
          allowedFileType={allowedFileType}
          flowInformation={flowInformation}
          entryMode={entryMode}
        />
      )}
    </div>
  )
}

export default MultimediaButtonProvider
